import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {FieldSelectorDialogComponent} from './components/field-selector-dialog/field-selector-dialog.component';
import {FieldGroupListComponent} from './components/field-group-list/field-group-list.component';
import {FieldGroupEditComponent} from './components/field-group-edit/field-group-edit.component';
import {DialogFieldComponent} from './components/dialog-field/dialog-field.component';
import {DatasourceService} from './services/datasource/datasource.service';
import {CalculationService} from './services/calculation/calculation.service';
import {FieldService} from './services/field/field.service';
import {FieldGroupService} from './services/field-group/field-group.service';
import {FieldOptionService} from './services/field-option/field-option.service';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UtilitiesModule} from '../utilities/utilities.module';
import {RouterModule} from '@angular/router';
import {FieldsModule} from '../fields/fields.module';
import { FieldEditorDialogComponent } from './components/field-editor-dialog/field-editor-dialog.component';
import {FieldEditorControllerService} from './services/field-editor-controller/field-editor-controller.service';
import {FieldFormControlService} from './services/field/field-form-control-service';
import { CalculationEditorComponent } from './components/calculation-editor/calculation-editor.component';
import { ArchiveFieldsComponent } from './components/archived-fields/archive-fields/archive-fields.component';
import {FieldGroupNameResolverService} from './resolvers/field-group-name-resolver.service';
import {FieldGroupEditorDialogComponent} from './components/field-group-editor-dialog/field-group-editor-dialog.component';

@NgModule({
  declarations: [
    FieldSelectorDialogComponent,
    FieldGroupListComponent,
    FieldGroupEditComponent,
    DialogFieldComponent,
    FieldEditorDialogComponent,
    CalculationEditorComponent,
    ArchiveFieldsComponent,
    FieldGroupEditorDialogComponent,
  ],
  entryComponents: [
    FieldSelectorDialogComponent,
    FieldEditorDialogComponent,
    FieldGroupEditorDialogComponent
  ],
  imports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    UtilitiesModule,
    RouterModule,
    ReactiveFormsModule,
    FieldsModule
  ],
  exports: [
    FieldGroupListComponent,
    FieldGroupEditComponent,
    FieldSelectorDialogComponent,
    DialogFieldComponent
  ],
  providers: [
    DatasourceService,
    CalculationService,
    FieldService,
    FieldGroupService,
    FieldOptionService,
    FieldEditorControllerService,
    FieldFormControlService,
    FieldGroupNameResolverService
  ]
})
export class FormBuilderModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/form-builder.module.ts